<div class="container">

  <h4 class="form-page-name">
      Loading
  </h4>

  <mat-progress-bar mode="indeterminate"></mat-progress-bar>

  <div style="min-height: 50px;"></div>

</div>
